export default __webpack_public_path__ + "9765d9c63ec34edff25459728227cb04.svg";